import ReadOnlyOdataServiceBase from "@/core/services/OdataReadOnlyServiceBase";


class ClientMenuItemsService extends ReadOnlyOdataServiceBase {

    static code = "203";
    code = "203";

    constructor () {
        super({
            sourcePath: "client-menu-items"
        });
    }

}

export default ClientMenuItemsService;
